import { RADashboardLayout } from "@/interfaces/raDashboard.interface"
import { RADashboardPortfolioType } from "../asset-enums"
import { RADashboardTabId } from "../tab-enums"
import DefaultMasterDashboardLayout from "./defaultMaster"

export const DefaultDashboardEquity: RADashboardLayout = {
  ...DefaultMasterDashboardLayout,
  suggestedPortfolioType: [RADashboardPortfolioType.Equity],
  initialTab: RADashboardTabId.Overview,
  tabLayouts: {
    ...DefaultMasterDashboardLayout.tabLayouts
  }
}

export default DefaultDashboardEquity;
